"use client";

import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useAtom } from "jotai";
import { showSideMenuAtom } from "@/hooks/showSideMenuAtom";

interface Props {
  size?: number;
}

const SvgMobileHeart: React.FC<Props> = ({ size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

const SideMenuFavorites: React.FC = () => {
  const router = useRouter();
  const t = useTranslation();
  const [, setShowSideMenu] = useAtom(showSideMenuAtom);
  return (
    <div
      className="d-flex align-items-center gap-2 w-100  dropdown-toggle side-menu-favorites-item"
      onClick={() => {
        router.push(PagesPaths.favorites);
        setShowSideMenu(false);
      }}
      style={{ background: "none", border: "none", cursor: "pointer" }}
    >
      <SvgMobileHeart size={18} />
      <span>{t.favorites}</span>
    </div>
  );
};

export default SideMenuFavorites;
